/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios'
import i18next from 'i18next'
import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {Spinner} from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import Modal from 'react-bootstrap/Modal'
import CurrencyInput from 'react-currency-input-field'
import {useTranslation} from 'react-i18next'
import Select from 'react-select'
import 'react-tabs/style/react-tabs.css'
import swal from 'sweetalert'
import {KTSVG} from '../../../../_metronic/helpers'
import {getAccessesPriceAll} from '../../../../api/modules/access/access'
import {getMaterialLisPricelist} from '../../../../api/modules/master-data/master'
import {getDetaildasar, getPricelistImport} from '../../../../api/modules/master-data/master_2'
import {fetchBasicPrices, headers} from '../../../../services/fetcher'
import {SelectPageSize} from '../../../../components/SelectPageSize/SelectPageSize'
import {useRowTable} from '../../../../hooks/useRowTable'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {
  filterSelector,
  resetFilterBasicPrices,
  setFilterBasicPrices,
  setIsFetchData,
} from '../../../../redux/slices/filterSlices'
import {objToParams} from '../../../../utils/objToParams'
import Pagination from '../../component/Pagination'
import {RowFilter} from './RowFilter'
import * as TableUI from '../../../../components/Table/Table'
import {StyledCard} from '../../../../components/StyledCard'
import {StyledButtonGroups} from '../../../../components/StyledButtonGroups'
import {HakAkses} from '../../../../components/mikro/getHakAkses'
import {authSelector} from 'src/redux/slices/authSlices'
import { InputFile } from 'src/app/components/InputFile'

type Props = {
  className: string
}

const TablePrice: React.FC<Props> = ({className}) => {
  const {roleId} = useAppSelector(authSelector)
  const {filterBasicPrices} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const {t} = useTranslation()
  const hakAkses = HakAkses()
  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const handleClose1 = () => setShow1(false)
  const handleShow1 = () => setShow1(true)

  const [btnLoading, setBtnLoading] = useState(false)
  const [price, setPrice] = useState<any[]>([])
  const [product, setProduct] = useState<any[]>([])
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(true)
  const [isError, setIsError] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [accesses, setAccesses] = useState<any>()
  const [files, setFiles] = useState({file: null})
  const [showUpload, setShowUpload] = useState(false)
  const [actived, setActived] = useState(false)

  const rowNumber = useMemo(() => {
    const per = filterBasicPrices?.per_page ?? 5
    return page * per - per
  }, [filterBasicPrices, page])

  const onFetchBasicPrices = useCallback(() => {
    setLoading(true)
    setIsError(false)
    fetchBasicPrices(filterBasicPrices)
      .then((res) => {
        const data = res.data.data
        setPrice(data.data)
        setPage(data.current_page)
        setNumberURL(data.links)
        setLoading(false)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filterBasicPrices])

  const gettemplate = async () => {
    window.open(
      `${
        process.env.REACT_APP_PI_BACKEND_API_MASTERDATA
      }/price-list/dasar/import/template?token=${localStorage.getItem('token')}`
    )
  }
  const credential = localStorage.getItem('credential')

  const handleUpload = async () => {
    setBtnLoading(true)
    const lang = i18next.language
    let file = files.file
    let formdata = new FormData()
    formdata.append('file', file!)
    // console.log(formdata)
    await getPricelistImport(lang, formdata, credential)
      .then((res: any) => {
        // console.log(res.data.data.message)
        swal({
          title: `${t('document uploaded successfully')}`,
          icon: 'success',
        }).then(() => {
          const inputfile = document.getElementById('upload') as HTMLInputElement
          inputfile!.value = ''
          setShowUpload(false)
          // getPrice()
          setActived(!actived)
        })
      })
      .catch((err: any) => {
        swal({
          title: t(err.response.data.message),
          icon: 'error',
        })
      })
    setBtnLoading(false)
  }

  useEffect(() => {
    const getProduct = async () => {
      const res = await getMaterialLisPricelist()
      const data = res.data.data
      setProduct(data)
    }

    const getAccessMenu = async () => {
      const res = await getAccessesPriceAll(roleId)
      setAccesses(res.data.data)
    }

    getAccessMenu()
    getProduct()
  }, [])

  const [productCode, setProductCode] = useState<any>()
  const [priceAdd, setPriceAdd] = useState<any>()
  const [isUpload, setIsUpload] = useState(false)

  const postPrice = async () => {
    const split = productCode.split(', ')
    setBtnLoading(true)
    axios
      .post(
        `${
          process.env.REACT_APP_PI_BACKEND_API_MASTERDATA
        }/price-list/dasar/create?credentials=${localStorage.getItem('credential')}`,
        {
          product_code: split[0],
          product_name: split[1],
          price: priceAdd,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((response) => {
        if (!response.data.error) {
          setIsUpload(true)
          swal({
            title: `${t('Harga Dasar Berhasil di Tambahkan')}`,
            icon: 'success',
          }).then(() => {
            handleClose()
            // getPrice()
            setActived(!actived)
          })
        }
      })
      .catch((error) => {
        swal({
          title: `${t(error.response.data.message)}`,
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const handleDelete = async (id: any) => {
    swal({
      title: `${t('Are You Sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    })
      .then(async (willDelete) => {
        if (willDelete) {
          await axios
            .delete(
              `${
                process.env.REACT_APP_PI_BACKEND_API_MASTERDATA
              }/price-list/dasar/delete/${id}?credentials=${localStorage.getItem('credential')}`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                  apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
                  Accept: 'application/json',
                  'Access-Control-Allow-Origin': '*',
                },
              }
            )
            .then((response) => {
              if (!response.data.error) {
                setIsUpload(true)

                swal({
                  title: `${t('Harga Dasar Berhasil di Hapus')}`,
                  icon: 'success',
                }).then(() => {
                  // getPrice()
                  setActived(!actived)
                })
              }
            })
            .catch((error) => {
              swal({
                title: `${t(error.response.data.message)}`,
                icon: 'error',
              })
            })
        }
      })
      .catch((err) => {
        swal({
          title: `${t('Data Failed to Delete')}`,
          icon: 'error',
        })
      })
  }

  // editPrice
  const [idEdit, setIdEdit] = useState('')
  const [productEdit, setProductEdit] = useState('')
  const [productNameEdit, setProductNameEdit] = useState('')
  const [priceEdit, setPriceEdit] = useState<any>()
  const [productCompile, setProductCompile] = useState<any>()
  const [editIndex, setEditIndex] = useState(0)
  const [loadingModal, setLoadingModal] = useState(false)

  const handleEdit = async (id: any) => {
    handleShow1()
    setLoadingModal(true)
    setIdEdit(id)

    const res = await getDetaildasar(id)
    const data = res.data.data

    setPriceEdit(data.price)
    setProductEdit(data.product_code.slice(-7))
    setProductNameEdit(data.product_name)
    setProductCompile(data.product_code + ', ' + data.product_name)
    setLoadingModal(false)
  }

  const editPrice = async (id: any) => {
    swal({
      title: `${t('Are You Sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        let text = productCompile
        const split = text.split(', ')

        setBtnLoading(true)
        axios
          .put(
            `${
              process.env.REACT_APP_PI_BACKEND_API_MASTERDATA
            }/price-list/dasar/edit/${idEdit}?credentials=${localStorage.getItem('credential')}`,
            {
              product_code: split[0],
              product_name: split[1],
              price: priceEdit,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
                Accept: 'application/json',
                'Access-Control-Allow-Origin': '*',
              },
            }
          )
          .then((response) => {
            setIsUpload(true)
            handleClose1()
            swal({
              title: `${t('Harga Dasar Berhasil Diperbarui')}`,
              icon: 'success',
            }).then(() => {
              // getPrice()
              setActived(!actived)
            })
          })
          .catch((error) => {
            swal({
              title: `${t(error.response.data.message)}`,
              icon: 'error',
            })
          })
          .finally(() => {
            setBtnLoading(false)
          })
      }
    })
  }

  const onReloadTable = () => {
    dispatch(resetFilterBasicPrices())
  }

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({colSpan: 8, onReloadTable})

  const paginateNumber = async (url: string) => {
    if (!url) return

    try {
      setLoading(true)

      const token = localStorage.getItem('token') as string
      const endpoint = `${url}&${objToParams(filterBasicPrices)}`
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })

      const data = res.data.data
      setPrice(data.data)
      setPage(data.current_page)
      setNumberURL(data.links)
      setLoading(false)
    } catch (error) {
      setIsError(true)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const getData = setTimeout(onFetchBasicPrices, 1000)
    return () => clearTimeout(getData)
  }, [onFetchBasicPrices])

  const options = product.map((item: any, index: any) => {
    return {
      _index: index,
      value: item.material_number + ', ' + item.material_description,
      label: item.material_number.slice(-7) + ' - ' + item.material_description,
    }
  })

  const [language, setLanguage] = useState<any>()
  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    return () => {
      onReloadTable()
    }
  }, [])

  return (
    <StyledCard>
      <StyledButtonGroups
        leftContent={
          <SelectPageSize
            initialValue={filterBasicPrices?.per_page ?? 5}
            onChange={(value: any) =>
              dispatch(setFilterBasicPrices({...filterBasicPrices, per_page: value?.value ?? 5}))
            }
          />
        }
        rightContent={
          <>
            {hakAkses?.create && (
              <>
                <button
                  className='btn btn-info me-2'
                  title={t('Download Template')}
                  onClick={() => gettemplate()}
                >
                  <KTSVG path='/media/icons/duotune/download.svg' />
                  {t('Download Template')}
                </button>
                <button
                  onClick={() => {
                    setShowUpload(true)
                  }}
                  className='btn btn-warning me-2'
                  title={t('Import')}
                >
                  <KTSVG path='/media/icons/duotune/cloud-arrow-up-fill.svg' />
                  {t('Import')}
                </button>
                <div className='d-flex justify-content-end'>
                  <button
                    onClick={handleShow}
                    title={t('add_price')}
                    className='btn btn-primary d-flex align-items-center'
                  >
                    <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                    {t('order-tambah')}
                  </button>
                </div>
              </>
            )}
          </>
        }
      />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <tr>
              <th>{t('No')}</th>
              <th>{t('Product Code')}</th>
              <th>{t('kontrak-nama')}</th>
              <th>{t('Harga')}</th>
              <th>{t('Created By')}</th>
              <th>{t('Created')}</th>
              <th>{t('Updated')}</th>
              <th>{t('order-aksi')}</th>
            </tr>
          </TableUI.THead>
          <TableUI.TBody>
            <RowFilter />
            {loading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : price.length === 0 ? (
              <RowEmptyData />
            ) : (
              price?.map((prices, _index) => (
                <tr key={_index}>
                  <td>{_index + 1 + rowNumber}</td>
                  <td>{prices?.product_code.slice(-7)}</td>
                  <td>{prices?.product_name}</td>
                  <td>
                    {i18next.language === 'en'
                      ? 'Rp' + prices?.price.toLocaleString('en', {maximumFractionDigits: 4})
                      : 'Rp' + prices?.price.toLocaleString('id', {maximumFractionDigits: 4})}
                  </td>
                  <td>
                    {prices?.created_by?.name == null
                      ? prices?.created_by
                      : prices?.created_by?.name}
                  </td>
                  <td>{prices?.created_at.slice(0, 10)}</td>
                  <td>{prices?.updated_at.slice(0, 10)}</td>
                  <td>
                    <div
                      className='d-flex justify-content-center'
                      style={{marginTop: '.5px', marginBottom: '.5px'}}
                    >
                      {hakAkses?.update && (
                        <button
                          onClick={() => handleEdit(prices.id)}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2'
                          title={t('ubah')}
                        >
                          <KTSVG path='/media/icons/duotune/pencil-fill.svg' />
                        </button>
                      )}
                      {hakAkses?.delete && (
                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                          title={t('Hapus')}
                          onClick={() => handleDelete(prices.id)}
                        >
                          <KTSVG path='/media/icons/duotune/trash-fill.svg' />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />

      <Modal show={show1} onHide={handleClose1} backdrop='static' keyboard={false} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t('ubah')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingModal ? (
            <div className='d-flex justify-content-center'>
              <Spinner animation='border' role='status'>
                {' '}
              </Spinner>
            </div>
          ) : (
            <>
              <Form.Group className='mb-3' controlId='formBasicEmail'>
                <Form.Label>{t('Product Code')}</Form.Label>
                <Select
                  isClearable
                  placeholder={t('pilih')}
                  defaultValue={
                    options[options.findIndex((option) => option.value === productCompile)]
                  }
                  onChange={(opt: any) => setProductCompile(opt?.value)}
                  options={options}
                />
              </Form.Group>
              <Form.Group className='mb-3' controlId='formBasicEmail'>
                <Form.Label>{t('Price')}</Form.Label>
                <InputGroup size='sm'>
                  <InputGroup.Text>
                    <span className='px-1'>Rp</span>
                  </InputGroup.Text>
                  <CurrencyInput
                    defaultValue={priceEdit}
                    className='form-control form-control-sm'
                    placeholder={t('Price')}
                    decimalSeparator={language === 'en' ? '.' : ','}
                    groupSeparator={language === 'en' ? ',' : '.'}
                    onValueChange={(value: any) => {
                      setPriceEdit(value)
                    }}
                    decimalsLimit={-1}
                  />
                </InputGroup>
                {/* <Form.Control type="number" value={priceEdit} onChange={e => setPriceEdit(e.target.value)} size="sm" /> */}
              </Form.Group>
              <div className='d-flex justify-content-end'>
                <Button variant='primary' onClick={editPrice} disabled={btnLoading}>
                  {btnLoading ? (
                    <Spinner animation='border' variant='light' size='sm' />
                  ) : (
                    t('ubah')
                  )}
                </Button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={showUpload}
        onHide={() => setShowUpload(false)}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Import')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table>
            <tr>
              <td style={{width: '120px'}}>
                <h6>{t('order-fileUnggah')}</h6>
              </td>
              <td className='w-75'>
                <InputFile
                    setFileName={(_: string) => {}}
                    setFiles={setFiles}
                    isBase64={false}
                />
              </td>
            </tr>
          </table>
          <div className='d-flex justify-content-end mt-5'>
            <Button
              variant='primary'
              className='w-100 '
              onClick={() => handleUpload()}
              disabled={btnLoading}
            >
              {btnLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                t('order-kirim')
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={show} onHide={handleClose} backdrop='static' keyboard={false} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t('order-tambah')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>{t('Product Code')}</Form.Label>
            <Select
              placeholder={t('pilih')}
              isClearable
              onChange={(opt: any) => setProductCode(opt?.value)}
              options={options}
            />
          </Form.Group>
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>{t('Price')}</Form.Label>
            <InputGroup size='sm'>
              <InputGroup.Text>
                <span className='px-1'>Rp</span>
              </InputGroup.Text>
              <CurrencyInput
                key={productCode}
                className='form-control form-control-sm'
                placeholder={t('Price')}
                decimalSeparator={language === 'en' ? '.' : ','}
                groupSeparator={language === 'en' ? ',' : '.'}
                onValueChange={(value: any) => {
                  setPriceAdd(value)
                }}
                decimalsLimit={-1}
              />
            </InputGroup>
          </Form.Group>
          <div className='d-flex justify-content-end'>
            <Button variant='primary' onClick={postPrice} disabled={btnLoading}>
              {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('buat')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </StyledCard>
  )
}

export {TablePrice}
